//auth
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
//top bar notifications
export const ADD_TOP_BAR_NOTIFICATION = 'ADD_TOP_BAR_NOTIFICATION'
export const REMOVE_TOP_BAR_NOTIFICATION = 'REMOVE_TOP_BAR_NOTIFICATION'
//mini toasts
export const ADD_MINI_TOAST = 'ADD_MINI_TOAST'
export const REMOVE_MINI_TOAST = 'REMOVE_MINI_TOAST'
//date
export const SET_CURRENT_DATE = 'SET_CURRENT_DATE'
//venues
export const SET_CURRENT_VENUE = 'SET_CURRENT_VENUE'
//events
export const SET_CURRENT_EVENTS = 'SET_CURRENT_EVENTS'
export const SET_CURRENT_EVENTS_TOTAL = 'SET_CURRENT_EVENTS_TOTAL'
//inventory
export const SET_CURRENT_INVENTORY = 'SET_CURRENT_INVENTORY'
//layout sections
export const SET_CURRENT_LAYOUT_SECTIONS = 'SET_CURRENT_LAYOUT_SECTIONS'
//user
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
//attribution
export const SET_CURRENT_ATTRIBUTION_ID = 'SET_CURRENT_ATTRIBUTION_ID'
//micro site
export const SET_CURRENT_MICRO_SITE_CONFIG = 'SET_CURRENT_MICRO_SITE_CONFIG'
export const SET_CURRENT_MICRO_SITE_CONFIG_EVENTS = 'SET_CURRENT_MICRO_SITE_CONFIG_EVENTS'
//day settings
export const SET_CURRENT_DAY_SETTINGS = 'SET_CURRENT_DAY_SETTINGS'
//membership
export const SET_CURRENT_MEMBERSHIP_PLAN = 'SET_CURRENT_MEMBERSHIP_PLAN'
export const SET_CURRENT_MEMBERSHIP_AFFILIATE = 'SET_CURRENT_MEMBERSHIP_AFFILIATE'
//inner iframe
export const SET_INNER_IFRAME_ID = 'SET_INNER_IFRAME_ID'
//checkout
export const SET_CHECKOUT_BOOKING = 'SET_CHECKOUT_BOOKING'
export const SET_CHECKOUT_CART = 'SET_CHECKOUT_CART'
export const SET_CHECKOUT_ORDER = 'SET_CHECKOUT_ORDER'
export const ADD_CART_ITEM = 'ADD_CART_ITEM'
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM'
export const START_CHECKOUT = 'START_CHECKOUT'
export const CLEAR_CHECKOUT_CART_ITEMS = 'CLEAR_CHECKOUT_CART_ITEMS'
export const SET_CHECKOUT_PAYMENT_TYPE = 'SET_CHECKOUT_PAYMENT_TYPE'
export const SET_CHECKOUT_PAYMENT_PROFILE = 'SET_CHECKOUT_PAYMENT_PROFILE'
export const SET_CHECKOUT_STRIPE_PAYMENT_REQUEST = 'SET_CHECKOUT_STRIPE_PAYMENT_REQUEST'
export const SET_CHECKOUT_STRIPE_PAYMENT_REQUEST_RESULT =
  'SET_CHECKOUT_STRIPE_PAYMENT_REQUEST_RESULT'
//config
export const SET_CONFIG_EVENT_ID = 'SET_CONFIG_EVENT_ID'
export const SET_CONFIG_ATTRIBUTION_ID = 'SET_CONFIG_ATTRIBUTION_ID'
export const SET_CONFIG_CLIENT = 'SET_CONFIG_CLIENT'
export const SET_CONFIG_AFFILIATE_ID = 'SET_CONFIG_AFFILIATE_ID'
export const SET_CONFIG_TRACKING_ID = 'SET_CONFIG_TRACKING_ID'
//order filters
export const SET_CURRENT_ORDER_FILTERS = 'SET_CURRENT_ORDER_FILTERS'
export const REMOVE_CURRENT_ORDER_FILTERS = 'REMOVE_CURRENT_ORDER_FILTERS'
//integrations
export const SET_CURRENT_INTEGRATIONS = 'SET_CURRENT_INTEGRATIONS'
//chat app
export const SHOW_CHAT_APP = 'SHOW_CHAT_APP'
export const HIDE_CHAT_APP = 'HIDE_CHAT_APP'
export const TOGGLE_CHAT_APP = 'TOGGLE_CHAT_APP'
//chat
export const SET_CURRENT_CHAT_MESSAGES = 'SET_CURRENT_CHAT_MESSAGES'
export const SET_CURRENT_CHAT_MESSAGES_TOTAL = 'SET_CURRENT_CHAT_MESSAGES_TOTAL'
export const SET_CURRENT_CHAT_MESSAGES_TOTAL_UNREAD = 'SET_CURRENT_CHAT_MESSAGES_TOTAL_UNREAD'



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js